export default "__VITE_ASSET__B$JWHHuF__"